<template>
  <div id="app1">
      <Carousel :slides="slides"></Carousel>
  </div>
</template>

<script>
import Carousel from './components/Carousel';

export default {
  name: 'AppS',
   data: () => ({
    slides: [
    "/wp-content/uploads/2023/12/DJI_02541-scaled-1.webp",
     "/wp-content/uploads/2023/12/DSC6728-scaled-1.webp",
    ]
  }),
  components: {
    Carousel,
  }
}
</script>
